import { assertNotEmpty } from '@festina-life/core'
import { type FormikProps, FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useAllConciseBranches } from '../../../uiModels/branches/useAllConciseBranches'
import type { BranchCreationInput } from '../types'
import { validate } from './helpers'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const BaseBranchSelectionStep = ({ state: { values } }: Props) => {
  const conciseBranches = useAllConciseBranches()
  const translate = useTranslate()

  assertNotEmpty(values.server)
  const allowedBaseBranches =
    values.category === 'main'
      ? []
      : (conciseBranches[values.server] ?? []).filter((specification) => {
          if (values.category === 'none') {
            return true
          }

          if (specification.branchCategory === 'none') {
            return false
          }

          return (
            values.category !== 'release' ||
            specification.branchCategory === 'release' ||
            specification.branchCategory === 'main'
          )
        })

  return (
    <>
      <p>
        {translate('branchCreationWizard.baseBranchSelectionStep.description', {
          category: values.category,
        })}
      </p>
      <FormikSelect
        options={allowedBaseBranches}
        name={validate('baseBranch')}
        label={translate('branchCreationForm.baseBranch.label')}
        disabled={!allowedBaseBranches?.length}
        renderFn={(specification) => specification.name ?? ''}
        keyFn={(specification) => specification.name ?? ''}
      />
    </>
  )
}
